export const CORRECT = 0;
export const FACTOR_CHANGED = 1;
export const FACTOR_CLOSED = 2;
export const OUTCOME_CLOSED = 3;
export const EVENT_CLOSED = 4;



// WEBPACK FOOTER //
// ./js/constants/BettingState.js